import axios from "axios"
import { DocumentosPendientesPorFirmarDtoProps } from "./DTOs/DocumentosPendientesPorFirmarDto"
import { documentoComercialAdapter } from "./DocumentoComercial.adapter"

export async function getDocumentoComercialPendienteFirmar(): Promise<DocumentosPendientesPorFirmarDtoProps> {
  const { data } = await axios.get(
    "/DocumentoComercial/cantidad-pendientes-firmar"
  )
  return documentoComercialAdapter(data)
}
